import { render, staticRenderFns } from "./RedemptionLanding.vue?vue&type=template&id=c350ffc2&scoped=true"
import script from "./RedemptionLanding.vue?vue&type=script&lang=js"
export * from "./RedemptionLanding.vue?vue&type=script&lang=js"
import style0 from "./RedemptionLanding.vue?vue&type=style&index=0&id=c350ffc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c350ffc2",
  null
  
)

export default component.exports